
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/sample-data",
      function () {
        return require("private-next-pages/sources/sample-data.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/sample-data"])
      });
    }
  